module.exports = __webpack_public_path__ + "assets/img/mask.ae0c6f76.png";